import { Component } from '@angular/core';
import { ModalComponent } from 'libs/shared/src/lib/component/modal/modal.component';
import { CustomRefundFailModalComponent } from './refund/refund-fail/refund-fail.component';
import { CustomRefundSuccessModalComponent } from './refund/refund-success/refund-success.component';
import { CustomRefundListModalComponent } from './refund/refund/refund.component';

@Component({
  selector: 'app-modal',
  template: '',
  standalone: false
})
export class CustomModalComponent extends ModalComponent {
  templates = {
    refundSuccess: CustomRefundSuccessModalComponent,
    refundFail: CustomRefundFailModalComponent,
    refundSelector: CustomRefundListModalComponent
  };
}
